<mat-accordion>
    <mat-expansion-panel [expanded]="item.open" (click)="item.updateState$.next({ open: !item.open })">
        <mat-expansion-panel-header>
            <mat-panel-title>{{ item.title }}</mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ item.description }}</p>
    </mat-expansion-panel>
</mat-accordion>
